module.exports = __webpack_public_path__ + "static/media/maca_mati.87ae943e.png";